import Cookies from 'js-cookie';

/**
 * Drop-in replacement for fetch() that automatically injects
 * Authorization: Bearer <session_token> on every request.
 * Falls back gracefully if no token is present.
 */
export function authFetch(url, options = {}) {
  const token = Cookies.get('session_token');
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return fetch(url, { ...options, headers, credentials: 'include' });
}
